import { InnerBox } from "@/components/elements/InnerBox";
import { TextWithLinks } from "@/components/commons/TextWithLinks";
import { CollapsibleSectionHeader, useCollapsible } from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider, black } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { FCC } from "@/types/common";
import { Stack, Typography, Collapse } from "@mui/material";

type TTalentInterviewEvaluationProps = {
  defaultValues?: Partial<TTalentForm>;
};

export const TalentInterviewEvaluation: FCC<TTalentInterviewEvaluationProps> = ({ defaultValues }) => {
  const { expanded, toggle } = useCollapsible();

  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <CollapsibleSectionHeader title="面談評価" expanded={expanded} onToggle={toggle} />

      <Collapse in={expanded}>
      {defaultValues?.interviewEvaluation?.length ? (
        <Stack
          mt={3}
          p={2}
          border={`1px solid ${black[99]}`}
          borderRadius={rounded.xs}
          component="pre"
          sx={{
            fontFamily: "inherit",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }}
        >
          <Typography variant="body14" color={black[30]} component="span">
            <TextWithLinks text={defaultValues.interviewEvaluation!} />
          </Typography>
        </Stack>
      ) : null}
      </Collapse>
    </InnerBox>
  );
};
